import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";

export const LanguageMessage = ({register,watch}) => {
    return(<>
    <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'}>
        <Grid item width={'200px'}>
            <FormControl fullWidth>
                <InputLabel>Language</InputLabel>
                <Select
                fullWidth
                label={'Langauge'}
                {...register("language.")}
                value={watch.language[0]}
                >
                    <MenuItem value={'English'}>English</MenuItem>
                    <MenuItem value={'Spanish'}>Spanish</MenuItem>
                </Select>
            </FormControl>
        </Grid>

    </Grid>
    
    </>)
};
